import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../contexts/AdminContext';

const QuickLogin = () => {
  const { isAuthenticated } = useAdmin();
  const navigate = useNavigate();

  if (isAuthenticated) {
    return null; // Don't show if already authenticated
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="bg-gray-800 text-white px-6 py-8 rounded-lg shadow-lg max-w-md">
          <h2 className="text-xl font-bold mb-4">Admin Access Required</h2>
          <p className="text-gray-300 mb-6">
            You need to be logged in as an administrator to access this page.
          </p>
          <button
            onClick={() => navigate('/admin/login')}
            className="bg-primary-600 hover:bg-primary-700 text-white px-6 py-2 rounded-lg font-medium transition-colors"
          >
            Go to Login Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuickLogin;
